import React from 'react';
import Icon from '../../../components/AppIcon';

const RepeatServicePanel = ({ data = {}, loading = false }) => {
  const repeatRate = data?.repeatRate || 0;
  const repeatClients = data?.repeatClients || 0;
  const totalClients = data?.totalClients || 0;
  const oneTimeClients = data?.oneTimeClients || 0;

  const getColorClass = (rate) => {
    if (rate >= 60) return 'text-success';
    if (rate >= 40) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Repeat" size={24} className="text-accent" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Tasa de Clientes Recurrentes
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-32">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : (
        <div className="space-y-6">
          {/* Main Metric */}
          <div className="text-center">
            <div className={`text-5xl font-bold ${getColorClass(repeatRate)} mb-2`}>
              {repeatRate?.toFixed(1)}%
            </div>
            <p className="text-sm text-muted-foreground">
              de clientes regresan para más servicios
            </p>
          </div>

          {/* Progress Bar */}
          <div className="space-y-2">
            <div className="flex justify-between text-sm text-muted-foreground">
              <span>Clientes Recurrentes</span>
              <span>{repeatClients} de {totalClients}</span>
            </div>
            <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
              <div
                className={`h-full transition-all duration-500 ${getColorClass(repeatRate)?.replace('text-', 'bg-')}`}
                style={{ width: `${repeatRate}%` }}
              />
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 mb-1">
                <Icon name="UserCheck" size={20} className="text-success" />
                <span className="text-2xl font-bold text-foreground">{repeatClients}</span>
              </div>
              <p className="text-xs text-muted-foreground">Clientes Recurrentes</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 mb-1">
                <Icon name="User" size={20} className="text-muted-foreground" />
                <span className="text-2xl font-bold text-foreground">{oneTimeClients}</span>
              </div>
              <p className="text-xs text-muted-foreground">Clientes Únicos</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RepeatServicePanel;